module.exports = __webpack_public_path__ + "static/media/beproact-interreg-nwe-vertical.cf531f65.png";